import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const arjSettingsPermissionsRouteLegacyRedirectRoute: InvariantJiraRoute = {
	name: 'arj-settings-permissions-redirect',
	path: '/secure/PortfolioPermissions.jspa',
};
